var map = {
	"./air-conditioner.svg": 1560,
	"./airplane.svg": 1561,
	"./airport.svg": 1562,
	"./approved.svg": 1563,
	"./aquapark.svg": 1564,
	"./arrow-answer-bubble.svg": 1565,
	"./arrow-back.svg": 1566,
	"./arrow-flight.svg": 1567,
	"./arrow-right-top.svg": 1568,
	"./arrow-right.svg": 1569,
	"./bar.svg": 1570,
	"./beach-surface-pebble.svg": 1571,
	"./beach-surface-platform.svg": 1572,
	"./beach-surface-sand-pebble.svg": 1573,
	"./beach-surface-sand.svg": 1574,
	"./beachsurface.svg": 1575,
	"./card.svg": 1576,
	"./check.svg": 1577,
	"./clock.svg": 1578,
	"./cvv.svg": 1579,
	"./double-arrow.svg": 1580,
	"./empty-hotel-map.svg": 1581,
	"./filters/clear-filters.svg": 1582,
	"./filters/filter-button.svg": 1583,
	"./filters/instant-confirm-colored.svg": 1584,
	"./filters/instant-confirm.svg": 1585,
	"./filters/search-distance.svg": 1586,
	"./filters/search-lift.svg": 1587,
	"./fire.svg": 1588,
	"./flight-direct-mobile.svg": 1589,
	"./flight-direct.svg": 1590,
	"./flight-direct__additional-mobile.svg": 1591,
	"./flight-direct__additional.svg": 1592,
	"./flight-transition-mobile.svg": 1593,
	"./flight-transition.svg": 1594,
	"./flight-transition__additional-mobile.svg": 1595,
	"./flight-transition__additional.svg": 1596,
	"./food.svg": 1597,
	"./free-cancellation-colored.svg": 1598,
	"./fuel-green.svg": 1599,
	"./fuel-white.svg": 1600,
	"./funicular.svg": 1601,
	"./gallery-empty.svg": 1602,
	"./garranty.svg": 1603,
	"./gender-female.svg": 1604,
	"./gender-male.svg": 1605,
	"./gender-unidentified.svg": 1606,
	"./gift.svg": 1607,
	"./glass.svg": 1608,
	"./gym.svg": 1609,
	"./hand-luggage.svg": 1610,
	"./heated-pool.svg": 1611,
	"./hold-luggage.svg": 1612,
	"./hotel-reply.svg": 1613,
	"./included-services.svg": 1614,
	"./included.svg": 1615,
	"./kids-club.svg": 1616,
	"./kids-menu.svg": 1617,
	"./kids-pool.svg": 1618,
	"./lightning.svg": 1619,
	"./lock.svg": 1620,
	"./logo.svg": 1621,
	"./lt-extra/bonus_insurance.svg": 1622,
	"./lt-extra/bonus_ivi.svg": 1623,
	"./luggage-wrapping.svg": 1624,
	"./man.svg": 1625,
	"./map-button.svg": 1626,
	"./map/collapse-arrows.svg": 1627,
	"./map/expand-arrows.svg": 1628,
	"./massage.svg": 1629,
	"./nanny.svg": 1630,
	"./only-lt-half.svg": 1631,
	"./parking.svg": 1632,
	"./payment-mir.svg": 1633,
	"./paymenttype.svg": 1634,
	"./plane-arrival.svg": 1635,
	"./plane.svg": 1636,
	"./private-beach.svg": 1637,
	"./rest_types/active.svg": 1638,
	"./rest_types/couples.svg": 1639,
	"./rest_types/family.svg": 1640,
	"./review-tab-selected.svg": 1641,
	"./sauna.svg": 1642,
	"./search-sorting.svg": 1643,
	"./searcher-empty-request.svg": 1644,
	"./searcher-filtered-empty.svg": 1645,
	"./sidebar-bottom-triangle.svg": 1646,
	"./sidebar-menu-active.svg": 1647,
	"./sign_additional.svg": 1648,
	"./ski-in-ski-out.svg": 1649,
	"./social-fb.svg": 1650,
	"./social-share.svg": 1651,
	"./social-vk.svg": 1652,
	"./special.svg": 1653,
	"./success_additional.svg": 1654,
	"./swimming-pool.svg": 1655,
	"./thumbs-up.svg": 1656,
	"./wave.svg": 1657,
	"./wifi.svg": 1658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978;